import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { MarqueeBand } from "@/components/site/MarqueeBand";
import { Manifesto } from "@/components/site/Manifesto";
import { Programs } from "@/components/site/Programs";
import { Impact } from "@/components/site/Impact";
import { Gallery } from "@/components/site/Gallery";
import { Voices } from "@/components/site/Voices";
import { InstagramFeed } from "@/components/site/InstagramFeed";
import { BlogPreview } from "@/components/site/BlogPreview";
import { GetInvolved } from "@/components/site/GetInvolved";
import { DonorWall } from "@/components/site/DonorWall";
import { ContactSection } from "@/components/site/ContactSection";
import { Footer } from "@/components/site/Footer";
import { scrollToId } from "@/lib/scroll";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (t) => {
      lenis.raf(t);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    if (location.hash) {
      const t = setTimeout(() => scrollToId(location.hash.slice(1)), 450);
      return () => clearTimeout(t);
    }
  }, [location.hash]);

  return (
    <div className="App bg-bone min-h-screen" data-testid="home-page">
      <div className="noise-overlay" />
      <Navbar />
      <main>
        <Hero />
        <MarqueeBand />
        <Manifesto />
        <Programs />
        <Impact />
        <Gallery />
        <Voices />
        <InstagramFeed />
        <BlogPreview />
        <GetInvolved />
        <DonorWall />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
